<template lang="pug">
  .component-client-registration
    .row
      .small-12.large-6.columns
        label
          | Plate
          input(type='text', placeholder='', v-model='body.plate')
        label
          | Model
          input(type='text', placeholder='', v-model='body.model')
        label
          | Odometer
          input(type='text', placeholder='', v-model='body.odometer')
        label
          | Color
          input(type='text', placeholder='', v-model='body.color')
      .small-12-large-6.columns
        label
          | Category
          selectize-category(@optionSelected="selectCategory")
        label
          | Fuel type
          fuel-type-select(@fuelTypeSelected="selectFuel")
        label
          | Brand
          selectize-vehicle-brand(@optionSelected="selectBrand")
        label Picture
          input(type="text", disabled, v-model="body.picture")
        kepler-file-upload(@sel="handleFileSelector", selectedPrefix="vehicles", selectedVisibility="public")
    .row
      .columns
        button.button(@click="formSubmit") Create
</template>
<script type="text/babel">
  import Dropzone from 'components/structure/Dropzone'
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
  import FuelTypeSelect from "../../components/structure/ui/lists/FuelTypeSelect";
  import KeplerFileUpload from "../../components/structure/KeplerFileUpload";
  import SelectizeCategory from "../../components/structure/ui/lists/selectize/SelectizeCategory";
  import SelectizeVehicleBrand from "../../components/structure/ui/lists/selectize/SelectizeVehicleBrand";


  export default {
    name: "BackofficeCreateVehicle",
    components: {
      SelectizeVehicleBrand,
      SelectizeCategory,
      KeplerFileUpload,
      FuelTypeSelect,
      Dropzone,
    },
    data() {
      return {
        vehicleBrands: [],
        showFileSelector: false,
        body: {
          plate: null,
          model: null,
          color: null,
          brand_id: null,
          category_id: null,
          fuel_type: null,
          odometer: null,
          picture: null,
          position: {
            latitude: 0,
            longitude: 0,
          }
        }
      }
    },
    computed: {},
    mounted() {

    },
    created() {
    },
    methods: {
      handleFileSelector(path) {
        this.body.picture = path
        this.showFileSelector = false
      },
      selectBrand(brand) {
        this.body.brand_id = brand.id
      },
      selectCategory(category) {
        this.body.category_id = category.id
      },
      selectFuel(fuel) {
        this.body.fuel_type = fuel.id
      },
      formSubmit() {
        KeplerBackofficeSdk.vehicles.make(this.body, (data) => {
          this.$router.push({name: 'vehicle', params: {id: data.id}})
        })
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateVehicle.vue?c5fd108a